// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1NWLT","list":"BalanceDue_list__3o3qP","listRow":"BalanceDue_listRow__2mk-k","total":"BalanceDue_total__1rOpP"};